import { DISMISS_ERROR } from '../../../shared/common/constants';

export const dismissError = () => ({
  type: DISMISS_ERROR,
});
